import { Utils } from "@/plugins/utils"
import router from "@/router"

const toDateInput = value => (value ? String(value).substr(0, 10) : null)

const normalizeEquipment = equipment => ({
	eqp: { ...equipment.eqp },
	lstEqm: (equipment.lstEqm || []).map(subclass => ({
		...subclass,
		eqm: { ...subclass.eqm, eqmdata: toDateInput(subclass.eqm.eqmdata) },
	})),
	lstEqc: (equipment.lstEqc || []).map(eqc => ({
		...eqc,
		eqcdatac: toDateInput(eqc.eqcdatac),
		eqcdatav: toDateInput(eqc.eqcdatav),
	})),
})

export default {
	namespaced: true,
	state: {
		lstEqp: [],
		lstActive: [],
		equipment: null,
		insert: false,
		update: false,
		loading: false,
		search: "",
		showInactive: false,
		type: "",
		itemsPerPage: 20,
		hasNext: false,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getEquipment(state) {
			return { ...state.equipment }
		},
		getSearch(state) {
			return state.search
		},
	},
	mutations: {
		set(state, equipment) {
			state.equipment = equipment ? normalizeEquipment(equipment) : null
			state.insert = false
			state.update = !!equipment
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.equipment = null
		},
		setNew(state, equipment) {
			state.equipment = normalizeEquipment(equipment)
			state.insert = true
			state.update = false
		},
		setParamsDataTable(state, payload) {
			state.lstEqp = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLstEqp(state, lstEqp) {
			state.lstEqp = lstEqp
		},
		setLstActive(state, lstActive) {
			state.lstActive = lstActive
		},
		setSearch(state, search) {
			state.search = search
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		add({ commit }) {
			commit("setNew", {
				eqp: {
					eqpid: 0,
					eqptag: "",
					eqpnome: "",
					eqpdiascal: 0,
					eqptipo: "E",
					eqpinativo: false,
					eqpobs: "",
				},
				lstEqm: [],
				lstEqc: [],
			})
		},
		async find({ commit, dispatch }, eqpid) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/OryxPlace/Equipment/Find/${eqpid}`)
				.then(response => {
					const equipment = Utils.ValidateAxiosResponse(response.data)
					if (!equipment) throw new Error("Equipamento não encontrado.")
					commit("set", equipment)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			const payload = await this._vm.$axios
				.post("/OryxPlace/Equipment/Insert", getters.getEquipment)
				.then(response => {
					const equipment = Utils.ValidateAxiosResponse(response.data)
					commit("set", equipment)
					router.replace(`/oryxpdv/equipamento/${equipment.eqp.eqpid}`)
					return equipment
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			const payload = await this._vm.$axios
				.put("/OryxPlace/Equipment/Update", getters.getEquipment)
				.then(response => {
					const equipment = Utils.ValidateAxiosResponse(response.data)
					commit("set", equipment)
					return equipment
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/OryxPlace/Equipment/Delete/${getters.getEquipment.eqp.eqpid}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/equipamentos")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			const url = `/OryxPlace/Equipment/Search?search=${encodeURIComponent(getters.getSearch)}&limit=${limit}&page=${page}&showInactive=${state.showInactive}&equipmentType=${state.type}`

			const payload = await this._vm.$axios
				.get(url)
				.then(response => {
					commit("setParamsDataTable", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					commit("setLstEqp", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async findActive({ commit, dispatch }) {
			return await this._vm.$axios
				.get("/OryxPlace/Equipment/FindActive")
				.then(response => {
					const lstActive = Utils.ValidateAxiosResponse(response.data)
					commit("setLstActive", lstActive)
					return lstActive
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
	},
}
